module.exports = __webpack_public_path__ + "img/sp4.5a14f091.svg";